import { api } from '../api';
import { transformVerifyDocumentErrorResponse } from './transformers/verifyDocumentErrorResponse';
import { transformVerifyEmailErrorResponse } from './transformers/verifyEmailErrorResponse';
import { transformVerifyMobilePhoneNumberErrorResponse } from './transformers/verifyPhoneNumberErrorResponse';
import ValidationEndpoints from './validation.endpoints';
import {
  VerifyDocumentRequest,
  VerifyEmailRequest,
  VerifyMobileRequest,
} from './validation.types';

const enhancedApi = api.injectEndpoints({
  endpoints: (build) => ({
    verifyEmail: build.mutation<void, VerifyEmailRequest>({
      query: (body) => ({
        url: ValidationEndpoints.VerifyEmail,
        method: 'POST',
        body,
      }),
      transformErrorResponse: transformVerifyEmailErrorResponse,
    }),
    verifyMobile: build.mutation<void, VerifyMobileRequest>({
      query: (body) => ({
        url: ValidationEndpoints.VerifyMobile,
        method: 'POST',
        body,
      }),
      transformErrorResponse: transformVerifyMobilePhoneNumberErrorResponse,
    }),
    verifyDocument: build.mutation<void, VerifyDocumentRequest>({
      query: (body) => ({
        url: ValidationEndpoints.VerifyDocument,
        method: 'POST',
        body,
      }),
      transformErrorResponse: transformVerifyDocumentErrorResponse,
    }),
  }),
});

export const {
  useVerifyEmailMutation,
  useVerifyMobileMutation,
  useVerifyDocumentMutation,
} = enhancedApi;
